/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-06-01 16:36:18
 * @FilePath: \client-h5\src\pages\my\index.jsx
 */
import React, { Component } from 'react';
import {
    List,
    Button,
    Toast,
} from 'antd-mobile';
import { getUserInfo, loginout } from "./services";
import { host } from "../../utils/util";

import './index.scss'
class My extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            myBg: require('../../assets/my-bg.png'),
            myAvater: require('../../assets/my-avater.png'),
            modifyIcon: require('../../assets/modifyIcon.png'),
            orderIcon: require('../../assets/orderIcon.png'),
            userInfo: '',
            rechargeRoom: '',
            showModal: false,
        }
    }

    componentDidMount() {
        document.title = '我的'
        this.getUserInfo();
        this.setState({
            rechargeRoom: JSON.parse(localStorage.getItem('roomData')),
        })
    }

    getUserInfo = () => {
        getUserInfo().then((res) => {
            this.setState({
                userInfo: res
            })
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
    }
    showComfirm = () => {
        this.setState({
            showModal: true
        })
    }
    loginout = () => {
        loginout().then((res) => {
            if (res.code == '200') {
                Toast.show({
                    content: '退出成功',
                })
                localStorage.clear();
                setTimeout(() => {
                    // this.props.history.replace('/transfer')
                    window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx92a2218861683826&redirect_uri='+host+'transfer&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect')
                },300)
                
            } else{
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
    }
    changeTel = () => {
        this.props.history.push('/bindTel?formPage=my')
    }
    changeRoom = () => {
        this.props.history.push('/bindRoom?formPage=my')
    }
    goCheckOrderList = () => {
        this.props.history.push('/orderList')
    }
    onCancle = ()=>{
        this.setState({showModal:false});
    }
    renderModal = () => {
        const { showModal } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModal ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModal ? "board display" : "board"}>
                    <div className="titile"><span>提示</span></div>
                    <div className='content mg6175'>
                        <div className="text-box">
                            <text className="t_value_center">是否退出登录</text>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span  className="cancel towBtn" onClick={this.onCancle}>取消</span>
                        <span  className="towBtn" onClick={this.loginout}>确定</span>
                    </div>
                </div>
            </>
        )
    }
    render() {
        const { myBg, myAvater, modifyIcon, orderIcon, userInfo, rechargeRoom } = this.state;
        const { account } = userInfo;
        let tel, room, projectName;

        if (rechargeRoom) {
            room = rechargeRoom.room;
            projectName = rechargeRoom.projectName;
        }
        if (account) {
            tel = account.telphone;
        }

        return (
            <div className="my-container">
                {this.renderModal()}
                <div>
                    <img className='myBg' src={myBg} />
                </div>
                <div className="padding-box">
                    <div className='myAvater-box'>
                        <img className='myAvater' src={myAvater} />
                    </div>
                    <div className='top-box'>
                        <div className='position'>

                            <div className='tel-box'>
                                <span className='font-27'>{tel}</span>
                                <img className='modifyIcon' src={modifyIcon} onClick={this.changeTel} />
                            </div>
                            <div className='area-box'>
                                <span className='font-20'>{projectName||'--'}<span className='verLine'>|</span>{room||'--'}</span>
                                <img className='modifyIcon' src={modifyIcon} onClick={this.changeRoom} />
                            </div>
                        </div>

                    </div>
                    <div className='list-box'>
                        <List>
                            <List.Item prefix={<img className='orderIcon' src={orderIcon} />} onClick={this.goCheckOrderList}>
                                买水订单
                            </List.Item>
                        </List>
                    </div>
                </div>
                <div className='btn-box'>
                    <Button className='loginout' shape='rounded' color='primary' fill='outline' onClick={this.showComfirm}>
                        退出登录
                    </Button>
                </div>
            </div>


        )
    }
}
export default My;

